import { getApiClient } from "@src/api";
import { graphql } from "@src/gql/gql";
import { handleError } from "@src/utils/error-handling";
import { useMutation } from "@tanstack/react-query";

const activateStarterMutation = graphql(/* GraphQL */ `
	mutation ActivateStarter {
		plans {
			activateStarter {
				causationId
				commandId
				correlationId
				id
				state {
					internalUserId
					provider
					renewsAt
					status
				}
			}
		}
	}
`);

/**
 * Mutation function for activating the starter plan.
 */
export const activateStarterMutationFn = async () => {
	const client = getApiClient();
	const result = await client.mutate({
		mutation: activateStarterMutation,
	});

	return result.data;
};

/**
 * Mutation options for activating the starter plan.
 */
export const activateStarterMutationOptions = {
	mutationFn: activateStarterMutationFn,
	onError: (error: Error) => {
		handleError(error, "Failed to activate starter plan");
	},
};

export const useActivateStarter = () =>
	useMutation(activateStarterMutationOptions);
